import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { METHODS, SERVICES } from '../../api/constants';
import { makeRequest } from '../../api/api';
import { MOODLE_BACKEND_ROUTES } from '../../config/apiRoutes';
import { commonMoodlePayload } from '../../config';

export const submitHandsonAttempt = createAsyncThunk(
  'handsonSlice/submitHandsonAttempt',
  async (params, thunkApi) => {
    try {
      const state = thunkApi.getState();
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...params,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.SUBMIT_HANDSON_ATTEMPT,
          wstoken: state.auth.token
        }
      );
      return response.data;
    } catch (e) {
      console.log(e);
      
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const fetchHandsonAttemptResults = createAsyncThunk(
  'handsonSlice/fetchHandsonAttemptResults',
  async (params, thunkApi) => {
    try {
      const state = thunkApi.getState();
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...params,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.GET_HANDSON_ATTEMPT_RESULTS,
          wstoken: state.auth.token
        }
      );
      return response.data;
    } catch (e) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const fetchProblemDetails = createAsyncThunk(
  'handsonSlice/fetchProblemDetails',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.GET_HANDSON_PROBLEM_DATA,
          wstoken: thunkApi.getState().auth.token
        }
      );

      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const fetchAllocatedInstance = createAsyncThunk(
  'handsonSlice/fetchAllocatedInstance',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.ONLYOFFICE_INSTANCE_LAMBDA,
        '',
        METHODS.GET,
        {}
      );

      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const createMoodleAttempt = createAsyncThunk(
  'handsonSlice/createMoodleAttempt',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.CREATE_HANDSON_ATTEMPT_ON_MOODLE,
          wstoken: thunkApi.getState().auth.token
        }
      );
      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const fetchProblemSet = createAsyncThunk(
  'handsonSlice/fetchProblemSet',
  async (params, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.VAUTH_NODE_APIS,
        `/authoring/fetch`,
        METHODS.GET,
        { ...params },
        {}
      );
      return response?.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const fetchProblemSubmissions = createAsyncThunk(
  'handsonSlice/fetchProblemSubmissions',
  async (params, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.VAUTH_NODE_APIS,
        `/submission/fetch`,
        METHODS.GET,
        { ...params }
      );
      return response?.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const createProblemSubmission = createAsyncThunk(
  'handsonSlice/createProblemSubmission',
  async (params, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.VAUTH_NODE_APIS,
        `/submission/create`,
        METHODS.POST,
        {},
        { ...params }
      );
      if (response?.data?.success) {
        thunkApi.dispatch(
          fetchProblemSubmissions({
            problemUserId: params?.problemUserId,
            problemType: 'Excel'
          })
        );
      }
      return response?.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

// Slice Definition
export const handsonSlice = createSlice({
  name: 'handsonSlice',
  initialState: {
    problemSetData: null,
    isProblemSetLoading: false, // TODO: this is called as soon as page loads, called right after we click on the activity from classroom(after moodle api is called and problem id is obtained -> isMoodleProblemDetailsLoading)         -> 2nd
    fetchProblemSetError: '',
    problemSubmissionData: [],
    isFetchProblemSubmissionLoading: false, // as soon as page loads, called once the problem id is obtained -> brings submissions ----------------> 2nd
    fetchProblemSubmissionError: '',
    createProblemSubmissionData: null,
    isCreateProblemSubmissionLoading: false, // on submit button click to save the details on mongodb        --------> 3rd
    createProblemSubmissionError: '',
    moodleProblemDetails: {},
    isMoodleProblemDetailsLoading: false, // TODO: this is called as soon as the page loads, and fetches problem id.              --------> 1st
    moodleProblemDetailsError: null,
    createMoodleAttemtData: {},
    isCreateMoodleAttemptLoading: false, // TODO: once submit button click to save the details on moodle       --------> 3rd
    createMoodleAttemptError: null,
    allocatedExcelInstance: null,
    isAllocateExcelInstanceLoading: false,
    // New state for hands-on emulator submission & timer
    isSubmitHandsonAttemptLoading: false,
    submitHandsonAttemptError: null,
    handsonAttemptResults: [],
    latestAttemptResult: null,
    isFetchAttemptResultsLoading: false,
    fetchAttemptResultsError: null,
    currentAttemptStartTime: null,
    attemptCount: 0,
    isSubmitted: false,
    timerExpired: false
  },
  reducers: {
    setCurrentAttemptStartTime: (state, action) => {
      state.currentAttemptStartTime = action.payload;
    },
    incrementAttemptCount: (state) => {
      state.attemptCount += 1;
    },
    resetAttemptState: (state) => {
      state.currentAttemptStartTime = null;
      state.attemptCount = 0;
      state.isSubmitted = false;
      state.timerExpired = false;
      state.handsonAttemptResults = [];
      state.latestAttemptResult = null;
      state.isSubmitHandsonAttemptLoading = false;
      state.submitHandsonAttemptError = null;
      state.isFetchAttemptResultsLoading = false;
      state.fetchAttemptResultsError = null;
    },
    setIsSubmitted: (state, action) => {
      state.isSubmitted = action.payload;
    },
    setTimerExpired: (state, action) => {
      state.timerExpired = action.payload;
    },
    resetHandsonState: (state) => {
      return {
        problemSetData: null,
        restrictedCols: [],
        isProblemSetLoading: false,
        fetchProblemSetError: '',
        problemSubmissionData: [],
        isFetchProblemSubmissionLoading: false,
        fetchProblemSubmissionError: '',
        createProblemSubmissionData: null,
        isCreateProblemSubmissionLoading: false,
        createProblemSubmissionError: '',
        moodleProblemDetails: {},
        isMoodleProblemDetailsLoading: false,
        moodleProblemDetailsError: null,
        createMoodleAttemtData: {},
        isCreateMoodleAttemptLoading: false,
        createMoodleAttemptError: null,
        allocatedExcelInstance: null,
        isAllocateExcelInstanceLoading: false,
        isSubmitHandsonAttemptLoading: false,
        submitHandsonAttemptError: null,
        handsonAttemptResults: [],
        latestAttemptResult: null,
        isFetchAttemptResultsLoading: false,
        fetchAttemptResultsError: null,
        currentAttemptStartTime: null,
        attemptCount: 0,
        isSubmitted: false,
        timerExpired: false
      };
    }
  },
  extraReducers: (builder) => {
    builder
      // fetchProblemSet
      .addCase(fetchProblemSet.pending, (state) => {
        state.isProblemSetLoading = true;
        state.fetchProblemSetError = null;
      })
      .addCase(fetchProblemSet.fulfilled, (state, action) => {
        state.isProblemSetLoading = false;
        state.problemSetData = action.payload?.data?.[0];
        let keys = Object?.keys(action.payload?.data?.[0]?.validations);
        let columns = keys.map((key) => key?.charCodeAt(0));
        state.restrictedCols = columns;
      })
      .addCase(fetchProblemSet.rejected, (state, action) => {
        state.isProblemSetLoading = false;
        state.fetchProblemSetError = action.payload;
        state.restrictedCols = [];
      })

      // fetchProblemSubmissions
      .addCase(fetchProblemSubmissions.pending, (state) => {
        state.isFetchProblemSubmissionLoading = true;
        state.fetchProblemSubmissionError = null;
      })
      .addCase(fetchProblemSubmissions.fulfilled, (state, action) => {
        state.isFetchProblemSubmissionLoading = false;
        state.problemSubmissionData = action.payload?.data?.[0] || [];
      })
      .addCase(fetchProblemSubmissions.rejected, (state, action) => {
        state.isFetchProblemSubmissionLoading = false;
        state.fetchProblemSubmissionError = action.payload;
      })

      // createProblemSubmission
      .addCase(createProblemSubmission.pending, (state) => {
        state.createProblemSubmissionData = true;
        state.createProblemSubmissionError = null;
      })
      .addCase(createProblemSubmission.fulfilled, (state, action) => {
        state.isCreateProblemSubmissionLoading = false;
        state.createProblemSubmissionData = action.payload?.data || [];
      })
      .addCase(createProblemSubmission.rejected, (state, action) => {
        state.isCreateProblemSubmissionLoading = false;
        state.createProblemSubmissionError = action.payload;
      })

      // fetchProblemDetails
      .addCase(fetchProblemDetails.pending, (state) => {
        state.isMoodleProblemDetailsLoading = true;
        state.moodleProblemDetailsError = null;
      })
      .addCase(fetchProblemDetails.fulfilled, (state, action) => {
        state.isMoodleProblemDetailsLoading = false;
        state.moodleProblemDetails = action.payload?.data || {};
      })
      .addCase(fetchProblemDetails.rejected, (state, action) => {
        state.isMoodleProblemDetailsLoading = false;
        state.moodleProblemDetails = {};
        state.moodleProblemDetailsError = true;
      })

      // createMoodleAttempt
      .addCase(createMoodleAttempt.pending, (state) => {
        state.isCreateMoodleAttemptLoading = true;
        state.createMoodleAttemptError = null;
      })
      .addCase(createMoodleAttempt.fulfilled, (state, action) => {
        state.isCreateMoodleAttemptLoading = false;
        state.createMoodleAttemtData = action.payload?.data || {};
      })
      .addCase(createMoodleAttempt.rejected, (state, action) => {
        state.isCreateMoodleAttemptLoading = false;
        state.createMoodleAttemtData = {};
        state.createMoodleAttemptError = true;
      })

      // fetchExcelInstance
      .addCase(fetchAllocatedInstance.pending, (state) => {
        state.isAllocateExcelInstanceLoading = true;
        state.allocatedExcelInstance = null;
      })
      .addCase(fetchAllocatedInstance.fulfilled, (state, action) => {
        state.isAllocateExcelInstanceLoading = false;
        state.allocatedExcelInstance = action?.payload?.port || null;        
        if (action?.payload?.port) {
          localStorage.setItem('ExcelInstance', action?.payload?.port);
        }
      })
      .addCase(fetchAllocatedInstance.rejected, (state, action) => {
        state.isAllocateExcelInstanceLoading = false;
        state.allocatedExcelInstance = null;
      })

      // submitHandsonAttempt
      .addCase(submitHandsonAttempt.pending, (state) => {
        state.isSubmitHandsonAttemptLoading = true;
        state.submitHandsonAttemptError = null;
      })
      .addCase(submitHandsonAttempt.fulfilled, (state, action) => {
        state.isSubmitHandsonAttemptLoading = false;
        state.isSubmitted = true;
      })
      .addCase(submitHandsonAttempt.rejected, (state, action) => {
        state.isSubmitHandsonAttemptLoading = false;
        state.submitHandsonAttemptError = action.payload;
      })

      // fetchHandsonAttemptResults
      .addCase(fetchHandsonAttemptResults.pending, (state) => {
        state.isFetchAttemptResultsLoading = true;
        state.fetchAttemptResultsError = null;
      })
      .addCase(fetchHandsonAttemptResults.fulfilled, (state, action) => {
        state.isFetchAttemptResultsLoading = false;
        const attempts = action.payload?.attempts || [];
        state.handsonAttemptResults = attempts;
        state.latestAttemptResult = attempts?.[0] || null;
      })
      .addCase(fetchHandsonAttemptResults.rejected, (state, action) => {
        state.isFetchAttemptResultsLoading = false;
        state.fetchAttemptResultsError = action.payload;
      });
  }
});
export const {
  resetHandsonState,
  setCurrentAttemptStartTime,
  incrementAttemptCount,
  resetAttemptState,
  setIsSubmitted,
  setTimerExpired
} = handsonSlice.actions;
export default handsonSlice.reducer;
